import { birkenIcons, goteborgsvarvetIcons, vasaloppetIcons, vatternrundanIcons } from "./generatedRoleIconNames";

export type RendererType = "default" | "dot" | "live" | "sign" | "roundImage" | "pinImage";

type IconBase = {
	id: string,
	name: string,
	asset: string,
	scale: number,
	fixedColor?: string,
	renderer?: RendererType,
	role?: string,
}

export type DefaultIcon = IconBase & {
	lineWidth?: number,
	renderer?: "default",
}

export type RoundImageIcon = IconBase & {
	renderer: "roundImage",
	width?: number,
	offsetY?: number,
}

export type SignIcon = IconBase & {
	renderer: "sign",
	letter?: string,
	circle?: boolean,
}

export type LiveIcon = IconBase & {
	renderer: "live",
}

export type DotIcon = IconBase & {
	width?: number,
	fixedColor?: string,
	renderer: "dot",
}

export type PinImageIcon = IconBase & {
	renderer: "pinImage",
}

export type Icon = DefaultIcon | DotIcon | LiveIcon | SignIcon | RoundImageIcon | PinImageIcon;

export function getIcons(): Icon[] {
	return icons;
}

export function getStartGoalIcons(): Icon[] {
	return startGoalIcons.filter(i => !i.id.includes("-goal"));
}

export function getIcon(icon: string): Icon {

	if (mapping.has(icon)) {
		icon = mapping.get(icon) as string;
	}

	if (icon.indexOf(":") > -1) {
		const [lib, name] = icon.split(":");
		return {
			id: icon,
			name: name,
			asset: `${lib}/${name}.svg`,
			scale: 1,
			renderer: "default",
		}
	}

	const i = allIcons.find(i => i.id == icon);
	if (i) {
		return i;
	}

	return {
		id: "",
		name: "",
		asset: "",
		scale: 1,
		renderer: "default",
	}
}

const generatedIcons: Icon[] = [
	{
		id: "live",
		name: "Live",
		asset: "",
		scale: 1,
		renderer: "live",
	},
	{
		id: "pos-marker",
		name: "Pos marker",
		asset: "",
		scale: 1,
		renderer: "dot",
		width: 20,
	},

]

const startGoalIcons: Icon[] = [
	{
		id: "start",
		name: "Start",
		asset: "",
		scale: 1,
		renderer: "pinImage",
	},
	{
		id: "ball-start",
		name: "Ball",
		asset: "",
		scale: 1,
		fixedColor: "#82b396",
		renderer: "default",
	},
	{
		id: "ball-start-goal",
		name: "Ball",
		asset: "goal.png",
		scale: 1.4,
		renderer: "default",
	},
	{
		id: "dot-start",
		name: "Dot",
		asset: "",
		scale: 1,
		fixedColor: "#fff",
		renderer: "dot",
	},
	{
		id: "oslo-start",
		name: "Oslo",
		asset: "oslo/start.png",
		scale: 1,
		role: "startsign",
		renderer: "roundImage",
		width: 64,
		offsetY: 3,
	},
	{
		id: "oslo-start-goal",
		name: "Oslo",
		asset: "oslo/goal.png",
		scale: 1,
		role: "startsign",
		renderer: "roundImage",
		width: 64,
		offsetY: 17,
	},
	{
		id: "oslo-start-reverse",
		name: "Oslo Reverse",
		asset: "oslo/start.png",
		scale: 1,
		role: "oslomaraton",
		renderer: "roundImage",
		width: 64,
		offsetY: 17,
	},
	{
		id: "oslo-start-reverse-goal",
		name: "Oslo",
		asset: "oslo/goal.png",
		scale: 1,
		role: "oslomaraton",
		renderer: "roundImage",
		width: 64,
		offsetY: 3,
	},
]

const icons: Icon[] = [

	{
		id: "parking",
		name: "Parking",
		asset: "",
		scale: 1,
		letter: "P",
		renderer: "sign",
		role: "hidden"
	},
	{
		id: "bus-stop",
		name: "Bus Stop",
		asset: "material-symbols/directions-bus.svg",
		scale: 1,
		renderer: "sign",
		role: "hidden"
	},
	{
		id: "car",
		name: "Car",
		asset: "material-symbols/directions-car.svg",
		scale: 1,
		renderer: "sign",
		role: "hidden"
	},




	{
		id: "ml-toa",
		role: "midnattsloppet",
		name: "ML Toa",
		asset: "midnattsloppet/toa.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-musik",
		role: "midnattsloppet",
		name: "ML Musik",
		asset: "midnattsloppet/Musik.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-vatska",
		role: "midnattsloppet",
		name: "ML Vätska",
		asset: "midnattsloppet/Vätska.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-flaska",
		role: "midnattsloppet",
		name: "ML Flaska",
		asset: "midnattsloppet/flaska.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-info",
		role: "midnattsloppet",
		name: "ML Info",
		asset: "midnattsloppet/info.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-aid",
		role: "midnattsloppet",
		name: "ML Sjukvård",
		asset: "midnattsloppet/Sjukvård.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-bag",
		role: "midnattsloppet",
		name: "ML Galge",
		asset: "midnattsloppet/galge.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-fruit",
		role: "midnattsloppet",
		name: "ML Frukt",
		asset: "midnattsloppet/Frukt.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-medal",
		role: "midnattsloppet",
		name: "ML Medalj",
		asset: "midnattsloppet/Medalj.png",
		scale: 1.3,
		renderer: "roundImage",
	},
	{
		id: "ml-powerbar",
		role: "midnattsloppet",
		name: "ML Powerbar",
		asset: "midnattsloppet/power-bar.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-coffee",
		role: "midnattsloppet",
		name: "ML Coffee",
		asset: "midnattsloppet/kaffe.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-shower",
		role: "midnattsloppet",
		name: "ML Shower",
		asset: "midnattsloppet/Dusch.svg",
		scale: 1.6,
		renderer: "roundImage",
	},
	{
		id: "ml-tshirt",
		role: "midnattsloppet",
		name: "ML T-shirt",
		asset: "midnattsloppet/tshirt.svg",
		scale: 1,
		renderer: "roundImage",
	},
	{
		id: "ml-metro",
		role: "midnattsloppet",
		name: "Metro",
		asset: "",
		scale: 1,
		letter: "T",
		circle: true,
		renderer: "sign",
	},
	{
		id: "ml-rail",
		role: "midnattsloppet",
		name: "Railway",
		asset: "",
		scale: 1,
		letter: "J",
		circle: true,
		renderer: "sign",
	},
	{
		id: "lk-rema",
		role: "lopskonsult",
		name: "Rema",
		asset: "lopskonsult/rema-raceday.svg",
		scale: 1,
		renderer: "roundImage",
	},
	{
		id: "lk-sparebank",
		role: "lopskonsult",
		name: "Sparebank",
		asset: "lopskonsult/sparebank1-raceday.svg",
		scale: 1,
		renderer: "roundImage",
	},
	{
		id: "lk-intersport",
		role: "lopskonsult",
		name: "Intersport",
		asset: "lopskonsult/intersport.svg",
		scale: 1,
		renderer: "roundImage",
	},
	{
		id: "lk-lilleholmestrand",
		role: "lopskonsult",
		name: "Lilleholmestrand",
		asset: "lopskonsult/lilleholmestrand.svg",
		scale: 1,
		renderer: "roundImage",
	},
	{
		id: "liveTest",
		role: "admin",
		name: "Live",
		asset: "",
		scale: 1,
		renderer: "live",
	},

	...birkenIcons.map(name => ({
		id: `birken-${name}`,
		role: "birken",
		name: name,
		asset: `birken/${name}.svg`,
		scale: 1.2,
		lineWidth: 1.5,
		renderer: "default" as const,
	})),

	...goteborgsvarvetIcons.map(name => ({
		id: `gbg-${name}`,
		role: "goteborgsvarvet",
		name: name,
		asset: `goteborgsvarvet/${name}.svg`,
		scale: 1,
		renderer: "default" as const,
	})),

	...vatternrundanIcons.map(name => ({
		id: `vr-${name}`,
		role: "vatternrundan",
		name: name,
		asset: `vatternrundan/${name}.svg`,
		scale: .85,
		renderer: "default" as const,
	})),

	...vasaloppetIcons.map(name => ({
		id: `vasaloppet-${name}`,
		role: "Vasaloppet",
		name: name,
		asset: `vasaloppet/${name}.svg`,
		scale: 1.15,
		renderer: "default" as const,
	})),
]

// Mapping from old icons to new icons (for backwards compatibility)
// Some icons have been remapped to similar icons from the new libraries.
const mapping = new Map(
	Object.entries({
		"water": "material-symbols:water-drop",
		"beerglass": "icons8:icons8-beer-glass-50",
		"bottle": "icons8:icons8-bottle-of-water-50",
		"plastic-bottle": "icons8:icons8-bottle-of-water-50",
		"waterglass": "material-symbols:water-full",
		"ambulance": "icons8:icons8-ambulance-50",
		"doctors-bag": "material-symbols:medical-services",
		"aid": "icons8:icons8-xbox-cross-50",
		"hospital": "material-symbols:local-hospital",
		"medical-bag": "material-symbols:medical-services",
		"bar": "material-symbols:wine-bar",
		"bed": "material-symbols:hotel",
		"bedroom": "material-symbols:hotel",
		"charging-battery": "icons8:icons8-charging-battery-50",
		"energy": "icons8:icons8-quick-mode-on-50",
		"energy2": "icons8:icons8-electricity-50",
		"energy-drink": "icons8:icons8-energy-drink-50",
		"door-hanger": "icons8:icons8-door-hanger-50",
		"food": "material-symbols:restaurant",
		"food-truck": "icons8:icons8-food-truck-50",
		"french-press": "icons8:icons8-french-press-50",
		"hotel-bed": "material-symbols:hotel",
		"info": "icons8:icons8-info-50",
		"information": "icons8:icons8-information-50",

		"music": "material-symbols:music-note",
		"people": "icons8:icons8-people-50",
		"restaurant": "material-symbols:restaurant",
		"running": "material-symbols:directions-run",
		"shopping-bag": "icons8:icons8-shopping-bag-50",
		"standing-man": "icons8:icons8-standing-man-50",
		// "parking": "material-symbols:local-parking",
		// "bus-stop": "material-symbols:directions-bus",
		// "car": "material-symbols:directions-car",
		"medal": "icons8:icons8-medal-first-place-50",
		"prize": "icons8:icons8-prize-50",
		"trophy": "material-symbols:trophy",
		"trophy-cup": "icons8:icons8-trophy-cup-50",
		"up-right": "icons8:icons8-circled-up-right-50",
		"shower": "icons8:icons8-shower-50",
		"shower2": "icons8:icons8-safety-shower-50",
		"light": "icons8:icons8-light-50",
		"cycling": "icons8:icons8-cycling-50",
		"cycling_mountainbike": "icons8:icons8-mountain-biking-50",
		"bike": "icons8:icons8-bike-path-50",
		"kayak": "icons8:icons8-kayaking-50",
		"swimming": "icons8:icons8-swimming-50",
		"clock": "icons8:icons8-clock-50",
		"clock2": "icons8:icons8-future-50",
		"toilet": "icons8:icons8-toilet-50",
		"landscape": "mdi:terrain",
		"camping-tent": "icons8:icons8-camping-tent-50",
		"hangar": "icons8:icons8-hangar-50",
		"home": "material-symbols:home",
		"pavilion": "icons8:icons8-pavilion-50",
		"tent": "icons8:icons8-tent-50",
		"wheelchair": "material-symbols:accessible",
	}))

//@ts-ignore
const allIcons = [...icons, ...startGoalIcons, ...generatedIcons];
